import { render, staticRenderFns } from "./InternalAddress.vue?vue&type=template&id=39d85f9a&scoped=true"
import script from "./InternalAddress.vue?vue&type=script&lang=js"
export * from "./InternalAddress.vue?vue&type=script&lang=js"
import style0 from "./InternalAddress.vue?vue&type=style&index=0&id=39d85f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d85f9a",
  null
  
)

export default component.exports